import styled from "@emotion/styled";
import TextureBG from "../../../../resources/images/home/bg_texture.png";
export const TextureBackground = styled("div")`
  width: 100%;
  background-image: url(${TextureBG});
  position: relative;
`;
